import React, { FC, useMemo, useState } from "react";
import { TextInput as PaperInput, TextInputProps } from "react-native-paper";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { AppTheme, useTheme } from "../../theme/colors";
import CopyIcon from "../../Icons/CopyIcon";

interface InputProps extends TextInputProps {
    onIconPress?: () => void;
}

const TextInput: FC<InputProps> = (props) => {
    const [inFocus, setInFocus] = useState<boolean>(false);
    const theme = useTheme();

    const { value, error } = props;

    const isPasswordField =
      props.secureTextEntry ||
      (props.label && props.label.toString().toLowerCase().includes("password"));

    const textInputIsInFocus = useMemo(
      () => Boolean(inFocus || !!value),
      [value, inFocus]
    );

    const styles = getStyles(textInputIsInFocus, theme);

    return (
      <View
        style={
          props.onIconPress && {
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
          }
        }
      >
          <PaperInput
            mode={props.mode || "outlined"}
            outlineColor={theme.PRIMARY}
            onFocus={(e) => {
                setInFocus(true);
                props.onFocus && props?.onFocus(e);
            }}
            onBlur={(e) => {
                setInFocus(false);
                props.onBlur && props?.onBlur(e);
            }}
            style={{
                marginVertical: inFocus ? 15 : 0,
                flex: props.onIconPress ? 0.95 : 1,
            }}
            outlineStyle={{ borderRadius: 8, borderColor: theme.LIGHT_GREY }}
            textContentType={isPasswordField ? "newPassword" : props.textContentType}
            autoComplete={isPasswordField ? "password-new" : props.autoComplete}
            {...props}
            label={
                <Text style={error ? styles.errorTextStyle : styles.labelTextStyle}>
                    {props.label}
                </Text>
            }
          />
          {props.onIconPress && (
            <View style={styles.buttonContainer}>
                <TouchableOpacity
                  onPress={props.onIconPress}
                  style={styles.iconButton}
                >
                    <CopyIcon color={theme.FORECOLOR} width={25} height={25} />
                </TouchableOpacity>
            </View>
          )}
      </View>
    );
};

export default TextInput;

const getStyles = (inFocus: boolean, theme: AppTheme) =>
  StyleSheet.create({
      labelTextStyle: {
          backgroundColor: theme.BACKGROUND,
      },
      errorTextStyle: {
          color: theme.ERROR,
          fontWeight: "bold",
          backgroundColor: theme.BACKGROUND,
      },
      iconButton: {
          marginTop: 3,
          width: 48.5,
          aspectRatio: 1,
          borderWidth: 1,
          borderColor: theme.LIGHT_GREY,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 8,
      },
      buttonContainer: {
          marginLeft: 10,
          flex: 0.1,
      },
  });